import { Component, OnDestroy, OnInit } from "@angular/core";
import { ToastrManager } from "ng6-toastr-notifications";
import { Validators, FormGroup, FormBuilder } from "@angular/forms";
import { SharedService } from "src/app/shared/Services/shared.service";
import { CoreService } from "../../Services/core.service";
import { TitleService } from 'src/app/shared/Services/title.service';
import { ActivatedRoute, Router } from "@angular/router";
import { LayoutService } from "src/app/shared/Services/layout.service";
import { LoaderService } from "src/app/shared/Services/loader.service";
import { ErrormessageService } from "src/app/shared/Services/errormessage.service";
import { StorageService } from "src/app/shared/Services/storage.service";
import { VerificationLinkStateService } from "src/app/shared/Services/verification-link-state.service";
import { LoggingService } from "src/app/shared/Services/NGLogger/logging-service.service";
import { Subject, catchError, of, takeUntil, tap } from "rxjs";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  private componentDestroyed$: Subject<void> = new Subject(); // For unsubscribing when the component is destroyed
  ResetPaswordForm!: FormGroup;
  NotMatch!: boolean;
  IsChangePasswordform: boolean = true;
  Profilelist!: any;
  Submited!: boolean;
  RouteText: string = '';
  CurrentItem: string;
  isSubmitClicked = false;
  tdslId: string = '';
  isMail: boolean = false;
  public showPassword: boolean = false;
  public showPasswordC: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private coreServices: CoreService,
    private toastr: ToastrManager,
    private shareservice: SharedService,
    private _titleService: TitleService,
    private route: ActivatedRoute,
    private layoutService: LayoutService,
    private loaderservice: LoaderService,
    private router: Router,
    private errorMessageService: ErrormessageService,
    private verificationLinkStateService: VerificationLinkStateService,
    private storageService: StorageService,
    private loggingService: LoggingService
  ) {
    var newTitle = 'Reset Password';
    this._titleService.setTitle(newTitle);
    this.storageService.clean();
    this.storageService.removeLocalStorage();
    this.storageService.reloadOnce();
    this.layoutService.setShowHeader(false);
    this.layoutService.setShowFooter(false);
    this.layoutService.setShowSidebar(false);
    this.route.queryParams.subscribe(params => {
      const id = "enc=" + params['enc'];
      this.RouteText = id !== null ? id : '';
      this.tdslId = id;
      this.Submited = false;

    });
    this.CurrentItem = "Reset Password";
    this.formInIt();
  }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {
    this.isMail = this.verificationLinkStateService.getMailVerified();
    this.VerifyLink();
  }

  formInIt() {

    this.ResetPaswordForm = this.formBuilder.group({
      newPassword: [
        "",
        [
          Validators.required,
          Validators.minLength(8),
        ],
      ],
      confirmPassword: [
        "",
        [
          Validators.required,
          Validators.minLength(8),
        ],
      ],
      Id: [
        this.RouteText
      ],
      updatedDate: [""],
    });
  }

  onSubmit() {
    this.Submited = true;
    const newPassword = this.ResetPaswordForm.controls["newPassword"].value;
    const confirmPassword =
      this.ResetPaswordForm.controls["confirmPassword"].value;

    if (newPassword === confirmPassword && this.isSubmitClicked) {
      this.NotMatch = false;
      if (this.ResetPaswordForm.valid) {
        try {
          this.updatePassword();
        } catch (error) {
          this.isSubmitClicked = false
          throw error;
        }
      } else {
        this.isSubmitClicked = false
      }
    } else {
      this.NotMatch = true;
      this.isSubmitClicked = false;
    }
  }

  updatePassword() {
    try {
      this.coreServices
        .resetPassword(this.ResetPaswordForm.value)
        .subscribe((res: any) => {
          if (res.succeeded) {
            this.toastr.successToastr(res.messages[0], "Done!");
            this.IsChangePasswordform = false;
          } else {
            this.isSubmitClicked = false
            this.toastr.errorToastr(res.messages[0], "", "top-right");
          }
        });
    } catch (error) {
      this.isSubmitClicked = false
      this.loaderservice.showLoader(false);
      this.loggingService.captureException(error);
      throw error;
    }
  }

  checkConfirm(e: any) {
    const newPassword = this.ResetPaswordForm.controls["newPassword"]?.value;
    const confirmPassword =
      this.ResetPaswordForm.controls["confirmPassword"]?.value;
    if (newPassword === confirmPassword && this.Submited) {
      this.NotMatch = false;
    }
    else if (newPassword != confirmPassword && this.Submited) {
      this.NotMatch = true;
    }

  }

  VerifyLink() {
    if (!this.isMail) {
      this.coreServices.VerifyLink(this.tdslId)
      .pipe(tap(
        (res: any) => {
          if (res.succeeded) {

          }
          else {
            this.errorMessageService.setErrorMessage(res?.messages[0]);
            this.loggingService.captureException(res?.messages[0]);
            this.router.navigate(["/error"]);
          }
        }),
        catchError((error) =>{
          this.loggingService.captureException(error); 
          return of(null);
        }),
        takeUntil(this.componentDestroyed$)
        )
        .subscribe();
    }
    else {
      this.verificationLinkStateService.resetMailVerified();
    }
  }

  redirectToLogin() {
    this.router.navigate(['/']).then(() =>
      window.location.reload()
    );
  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  public togglePasswordVisibilityC(): void {
    this.showPasswordC = !this.showPasswordC;
  }
}
